import { useState, useContext, useEffect } from 'react';
import { Headline, HeaderFixed, Divider, Translate } from '@/components';
import peachjarLogo from '@/assets/logo.svg';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { ButtonPrimarySmall } from '@peachjar/ui/dist/lib/components/Buttons';
import AuthenticationContext from '@/context/AuthenticationContext';
import styles from './LoginDemo.styles';

type User = {
  userId: string;
  userName: string;
  folder: string;
};

export const LoginDemo: React.FC = () => {
  const { demoAuthentication } = useContext(AuthenticationContext);
  const [userName, setUserName] = useState<string>('');
  const [users, setUsers] = useState<Array<User>>([]);

  useEffect(() => {
    const getUsers = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_MOCK_API}/testCases.json`,
      );

      const data = (await response.json()) as Array<User>;
      setUsers(data);
    };

    getUsers();
  }, []);

  const handleSelectUser = (event: SelectChangeEvent) => {
    setUserName(event.target.value);
  };

  const onSubmit = async () => {
    demoAuthentication(userName);
  };

  return (
    <div>
      <HeaderFixed>
        <div className={styles.header}>
          <img
            src={peachjarLogo}
            alt="Peachjar Logo"
            width="101px"
            height="32px"
            data-testid="peachjarLogo"
          />
        </div>
        <Divider />
      </HeaderFixed>
      <div className={styles.container}>
        <div className={styles.content}>
          <Headline>Welcome Back!</Headline>
          <form
            className={styles.form}
            onSubmit={(e: any) => e.preventDefault()}
          >
            <FormControl variant="standard" fullWidth data-testid="userInput">
              <InputLabel data-testid="userInputLabel">
                <Translate>Select an user account</Translate>
              </InputLabel>
              <Select
                value={userName}
                onChange={handleSelectUser}
                data-testid="userInputSelect"
              >
                {users.map(({ userName, folder }) => (
                  <MenuItem
                    className={styles.selectOption}
                    value={folder}
                    data-testid="userEmailInputOption"
                    key={userName}
                  >
                    {userName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div className={styles.buttonWrapper}>
              <ButtonPrimarySmall
                id="btnSubmit"
                className={styles.btnSubmit}
                disabled={!userName}
                onClick={onSubmit}
              >
                Log In
              </ButtonPrimarySmall>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
